import { jsx as a, jsxs as s, Fragment as p } from "react/jsx-runtime";
import { Badge as l, Icon as _ } from "@strata/react-status-icons";
import d from "classnames";
import { Fragment as h } from "react";
import { useMatch as v, NavLink as m } from "react-router-dom";
import { MenuItem as u, MenuDivider as N, Drawer as b, DrawerSize as g, Position as w } from "@blueprintjs/core";
import { DropdownMenu as I } from "@strata/react-dropdown-menu";
import "./main.scss";
const f = ({ link: n }) => {
  const e = v({ path: n.to, end: n.end ?? !1, caseSensitive: !1 });
  return /* @__PURE__ */ a(
    u,
    {
      multiline: !0,
      className: d("sds_main-navbar-dropdown__menu-item", {
        "sds_main-navbar-dropdown__menu-item--active": e
      }),
      tagName: "span",
      icon: n.icon,
      text: /* @__PURE__ */ s(
        m,
        {
          className: ({ isActive: r }) => d("sds_main-navbar-dropdown__link", {
            "sds_main-navbar-dropdown__link--active": r
          }),
          to: n.to,
          end: n.end,
          target: n.openInNewTab ? "_blank" : void 0,
          rel: n.openInNewTab ? "noreferrer" : void 0,
          children: [
            n.label,
            /* @__PURE__ */ a(l, { count: n.badgeCount, intent: n.badgeIntent })
          ]
        }
      )
    }
  );
}, c = "DIVIDER", D = ({ tab: n }) => {
  var r;
  const e = v({ path: n.to, end: n.end ?? !1, caseSensitive: !1 });
  return /* @__PURE__ */ a(
    I,
    {
      className: "sds_main-navbar-dropdown__target",
      popoverClassName: "sds_main-navbar-dropdown",
      menuContent: (r = n.children) == null ? void 0 : r.map(
        (o, i) => o === c ? (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ a(N, {}, i)
        ) : /* @__PURE__ */ a(f, { link: o }, o.label)
      ),
      children: /* @__PURE__ */ s("div", { className: "sds_main-navbar-dropdown__target", children: [
        /* @__PURE__ */ a(
          "span",
          {
            title: n.label,
            className: d("sds_main-navbar__link", {
              "sds_main-navbar__link--active": e
            }),
            children: n.label
          }
        ),
        /* @__PURE__ */ a("div", { style: { position: "relative" }, children: /* @__PURE__ */ a(l, { count: n.badgeCount, intent: n.badgeIntent }) })
      ] })
    }
  );
}, C = ({ navTabContent: n }) => /* @__PURE__ */ a("nav", { className: "sds_main-navbar", children: n.map((e) => /* @__PURE__ */ a(h, { children: (e.children ?? []).length > 0 ? /* @__PURE__ */ a(D, { tab: e }) : /* @__PURE__ */ s(p, { children: [
  /* @__PURE__ */ s(
    m,
    {
      className: ({ isActive: r }) => d("sds_main-navbar__link", {
        "sds_main-navbar__link--active": r,
        "sds_main-navbar__link--external": e.openInNewTab
      }),
      to: e.to,
      end: e.end,
      title: e.label,
      target: e.openInNewTab ? "_blank" : void 0,
      children: [
        e.icon && /* @__PURE__ */ a(_, { icon: e.icon }),
        e.label
      ]
    }
  ),
  /* @__PURE__ */ a("div", { style: { position: "relative" }, children: /* @__PURE__ */ a(l, { count: e.badgeCount, intent: e.badgeIntent }) })
] }) }, e.label)) });
C.DIVIDER = c;
const R = ({
  navTabContent: n,
  isOpen: e,
  onMobileMenuClose: r,
  usePortal: o
}) => /* @__PURE__ */ a(
  b,
  {
    isOpen: e,
    position: w.LEFT,
    usePortal: o,
    size: g.LARGE,
    className: "theme--sds_dark sds_main-navbar-mobile__drawer",
    backdropClassName: "sds_main-navbar-mobile__backdrop",
    onClose: r,
    canOutsideClickClose: !0,
    canEscapeKeyClose: !0,
    children: /* @__PURE__ */ a("nav", { className: "sds_main-navbar-mobile padding__around--x-large", children: [{ label: "Home", to: "/home", end: !0 }, ...n ?? []].map(
      (i) => i.children ? i.children.filter((t) => t !== c) : i
    ).flat().map((i) => /* @__PURE__ */ s(
      m,
      {
        className: ({ isActive: t }) => d("sds_main-navbar-mobile__link", {
          "sds_main-navbar-mobile__link--active": t
        }),
        to: i.to,
        end: i.end,
        title: i.label,
        onClick: r,
        children: [
          i.icon && /* @__PURE__ */ a(_, { className: "margin__right--small", icon: i.icon }),
          i.label,
          /* @__PURE__ */ a(l, { count: i.badgeCount, intent: i.badgeIntent })
        ]
      },
      i.label
    )) })
  }
);
export {
  C as MainNavBar,
  R as MainNavBarMobile
};
//# sourceMappingURL=index.js.map
